import React from "react";
import { ActionButton, ToggleSwitch } from "../../../helper/ImageFormat";
import Spinner from "../../../Components/spinner";
import CustomPagination from "../../../helper/Pagination";
import { useNavigate } from "react-router-dom";
import dateformate from "../../../helper/DateFormate";

const AttributeTable = ({
  loading,
  attributeData,
  currentPage,
  perPage,
  handleEditClick,
  handleDelete,
  handleStatusToggle,
  totalCount,
  totalPages,
  handlePageClick,
  handleFilterToggle,
}) => {
  const navigator = useNavigate();
  const Tableheader = [
    "Name",
    "Key",
    "Type",
    "Values",
    "Updated At",
    "Is Filter",
    "Is Active",
    "Action",
  ];
  return (
    <div className="row">
      <div className="col-md-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <div className="pb-20 table-responsive">
              <table className=" custom-table table table-striped" id="attibute">
                <thead>
                  <tr>
                    {Tableheader &&
                      Tableheader.length > 0 &&
                      Tableheader.map((item, index) => (
                        <th className="font-weight-bold" key={index}>
                          {item}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="9" className="text-center">
                        <Spinner />
                      </td>
                    </tr>
                  ) : attributeData.length > 0 ? (
                    attributeData?.map((attribute, id) => {
                      return (
                        <tr key={id}>
                          <td>{attribute?.name}</td>
                          <td>{attribute?.key}</td>
                          <td>{attribute?.type}</td>
                          

                          <td>
                            {["Dropdown", "MultipleSelect", "CheckBox", "Redio"].includes(
                              attribute?.inputType
                            ) ? (
                              <button
                                type="button"
                                className="count-button1"
                                onClick={() => {
                                  navigator(`/attribute-value/${attribute.id}?value=${attribute.key}`,
                                    { state: attribute });
                                }}
                              >
                                {attribute?._count?.children || 0}
                              </button>
                            ) : (
                              <p>--</p>
                            )}
                          </td>
                          <td >{dateformate(attribute.updatedAt)}</td>
                          {/* <td className="text-center col-2">{dateformate(attribute.createdAt)}</td> */}

                          <td>
                            <ToggleSwitch
                              data={attribute}
                              name="showInFilter"
                              checked={attribute?.showInFilter}
                               module={"Attributes"}
                              handleStatusToggle={handleFilterToggle}
                            />
                          </td>

                          <td>
                            <ToggleSwitch
                              data={attribute}
                              name="isActive"
                              checked={attribute?.isActive}
                              module={"Attributes"}
                              handleStatusToggle={handleStatusToggle}
                            />
                          </td>

                          <td>
                            <ActionButton
                              data={attribute}
                              handleEditClick={handleEditClick}
                              handleDelete={handleDelete}
                              module={"Attributes"}
                            />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        <h4> No data available</h4>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {attributeData.length > 0 && (
              <div>
                <CustomPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageClick}
                  perPage={perPage}
                  totalCount={totalCount}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttributeTable;
